import { DOCX_FILE_EXTENSION, MAX_DOCX_FILE_SIZE_BYTES } from '../constants';
import type { ClauseDocxImportError } from '../types';

export const validateDocxFile = (file: File): ClauseDocxImportError | null => {
  if (!file.name.toLowerCase().endsWith(DOCX_FILE_EXTENSION)) {
    return 'unsupportedType';
  }

  if (file.size > MAX_DOCX_FILE_SIZE_BYTES) {
    return 'tooLarge';
  }

  return null;
};

// Password-protecting a .docx re-wraps it as an OLE compound file with an EncryptedPackage
// stream; legacy binary .doc files share the container signature, so the stream name is required.
const CFB_SIGNATURE = [0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1];

const ENCRYPTED_PACKAGE_STREAM_NAME = Array.from('EncryptedPackage').flatMap((char) => [char.charCodeAt(0), 0]);

const includesBytes = (bytes: Uint8Array, sequence: number[]): boolean => {
  for (let offset = 0; offset <= bytes.length - sequence.length; offset += 1) {
    if (sequence.every((byte, index) => bytes[offset + index] === byte)) {
      return true;
    }
  }

  return false;
};

export const isEncryptedDocx = async (file: File): Promise<boolean> => {
  const bytes = new Uint8Array(await file.arrayBuffer());

  return (
    bytes.length >= CFB_SIGNATURE.length &&
    CFB_SIGNATURE.every((byte, index) => bytes[index] === byte) &&
    includesBytes(bytes, ENCRYPTED_PACKAGE_STREAM_NAME)
  );
};
